import { useRejectProposal } from 'v2/hooks';
import { ExtraProposalRejectionOption } from './useProposalRejectionSelectOptions';

type SubmitProposalRejectionProps = {
  reason: string;
  proposalRejectionOptionID: number | ExtraProposalRejectionOption.other | null;
};

export function useSubmitProposalRejection(proposalID: number) {
  const { mutate: rejectProposal } = useRejectProposal();

  const onSubmit = ({
    reason,
    proposalRejectionOptionID,
  }: SubmitProposalRejectionProps) => {
    if (proposalRejectionOptionID === ExtraProposalRejectionOption.other) {
      return rejectProposal({
        id: proposalID,
        reason,
        proposalRejectionOptionID: null,
      });
    }

    return rejectProposal({
      id: proposalID,
      reason,
      proposalRejectionOptionID,
    });
  };

  return onSubmit;
}
